import { formatBatchDiscountNthText, formatPrice } from '~/src/common/utils/prices';
import { Home200ItemsItemProductsItemOneOfPromo } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  packSize: number;
  price: number;
  promo: Home200ItemsItemProductsItemOneOfPromo;
}

const PromoPrice = ({ promo, packSize, price }: Props) => {
  const { itemOriginalPrice, mechanism, conditions } = promo;

  const isBatchDiscount = mechanism === 'BATCH_DISCOUNT';
  const finalPrice = isBatchDiscount ? itemOriginalPrice * packSize : price * packSize;

  return isBatchDiscount ? (
    <S.BatchPromoPriceContainer>
      <span>{formatPrice(finalPrice)}</span>
      <span>
        {conditions?.nthQuantity
          ? formatBatchDiscountNthText({
              itemOriginalPrice: promo.itemOriginalPrice,
              nthQuantityOffered: conditions.nthQuantity,
              type: conditions.type,
              value: conditions.value,
            })
          : ''}
      </span>
    </S.BatchPromoPriceContainer>
  ) : (
    <S.ImmediatePromoPriceContainer>
      <span>{formatPrice(finalPrice)}</span>
      <span>{itemOriginalPrice ? formatPrice(itemOriginalPrice * packSize) : ''}</span>
    </S.ImmediatePromoPriceContainer>
  );
};

export default PromoPrice;
